export type MessagesTypes = {
    question?: string;
    detail?: {
        message: string;
        severity: 'error' | 'warning' | 'info' | 'success';
    };
    validation?: string;
    annulation?: string;
    alternative?: string;
};

export const updateConfigModalMessages: MessagesTypes = {
    question: 'Êtes-vous sûr de vouloir mettre à jour ce paramètre ?',
    validation: 'Oui, je souhaite modifier ce paramètre',
    annulation: 'Non, annuler la modification',
};
